import * as React from 'react';
import { d3AverageChart } from '../../../interface/VendorReportInterface2025';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell } from 'recharts'
import { numberWithCommas, numberWithDollarSign } from '../../Common/Helpers';


export class AverageEmployeesChart extends React.Component<d3AverageChart, {}> {
    render() { 
        let the_width = (this.props.normal_or_large == 0) ? 580 : 900;
        let the_height = (this.props.normal_or_large == 0) ? 200 : 600;
        let scale = this.props.scale ? this.props.scale : 1;
        let the_margin = (this.props.normal_or_large == 0) ? { top: 0, right: 10, left: 80*scale, bottom: 0 } :
            { top: 15, right: 0, left: 75, bottom: 45 };

        let iconSize = (this.props.normal_or_large == 0) ? 14 : 24;
        let payload = [];
        let the_fontsize = (this.props.normal_or_large == 0) ? 13 : 15;

        let bardata = []; 

        bardata.push({ name: "University Vendors", Employees: this.props.selectedVendorProfile.university_emp_mean });
        if (this.props.withNational) {
            bardata.push({ name: "National Average", Employees: this.props.selectedVendorProfile.national_emp_mean });
        }
        const fill = ["#c1d7d8", "#8884d8", "#82ca9d", "#5cbae6", "#b6d957", "#fac364", "#8cd3ff", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8", "#52bacc", "#dbdb46", "#98aafb"];

        return <div><h5>Average Number of Employees</h5>
            <BarChart width={the_width*scale} height={the_height*scale} data={bardata}
                layout="vertical" margin={the_margin} >
                <Tooltip />
                <XAxis type="number" dataKey="Employees" tick={{ fontSize: the_fontsize }} />
                <YAxis type="category" dataKey="name" tick={{ fontSize: the_fontsize }} />
                <CartesianGrid stroke="#f5f5f5" />
                <Bar barSize={40*scale} dataKey="Employees" fill={fill[1]}></Bar>
            </BarChart>
            <div className="axis_label">Number of employees</div>
        </div>
        
    }
}
